import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from '@angular/material/paginator';
import { SessionService } from "src/app/session.service";
import { AssistantService } from 'src/app/shared/assistant.service';
import { UiService } from 'src/app/ui/ui.service';

@Component({
  selector: 'app-generate-preview',
  templateUrl: './generate-preview.component.html',
  styleUrls: ['./generate-preview.component.scss']
})
export class GeneratePreviewComponent implements OnInit {

  data: any;
  loading = true;
  variations: any[] = [];
  currentVariation = -1;

  constructor(
    private dialogRef: MatDialogRef<GeneratePreviewComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      integrationId: number,
      type: string,
      name: string,
      width: number,
      height: number,
      prompt: string,
    },
    private SessionService: SessionService,
    private uiService: UiService,
    private assistSvc: AssistantService,
  ) {
    this.data = data;
  }

  ngOnInit(): void {
    //console.log('GeneratePreviewComponent ngOnInit');
    //console.log('this.data', this.data);
    this.generate();
  }

  generate() {
    this.loading = true;
    this.assistSvc.generateImage(this.SessionService.currentAccountValue!.accountID, this.SessionService.currentAppValue!.id, this.data.integrationId, this.data).subscribe((response: any) => {
      //console.log('generateImage result', response);
      this.loading = false;
      this.variations.push(response.result);
      this.currentVariation = this.variations.length - 1;
    }, (error) => {
      this.dialogRef.close(error.error);
    });
  }

  selectVariation(event: any) {
    this.currentVariation = event.pageIndex;
  }

  rangeLabel(page: number, pageSize: number, length: number) {
    return `${this.currentVariation + 1} of ${this.variations.length}`;

  }

  accept() {
    this.dialogRef.close(this.variations[this.currentVariation]);
  }

  reject() {
    this.dialogRef.close();
  }

  regenerate() {
    this.generate();
  }

  cancel() {
    this.dialogRef.close();
  }

}
